import { z } from "zod";
import { MatchingStrategyEnum, UrgencyEnum, ExpertMinimalSchema, UserMinimalSchema } from "../leads-v2/common";

// Re-export shared enums from leads-v2
export { MatchingStrategyEnum, UrgencyEnum };

// ==================
// Expert Schema for Draft Leads
// ==================

/** Expert info in draft lead (minimal) */
export const DraftLeadExpertSchema = z.object({
    id: z.number().int(),
    name: z.string(),
});

export type DraftLeadExpert = z.infer<typeof DraftLeadExpertSchema>;

// ==================
// Packaged Service Schema
// ==================

/** Packaged service info in draft lead */
export const DraftLeadPackagedServiceSchema = z.object({
    id: z.number().int(),
    name: z.string(),
});

export type DraftLeadPackagedService = z.infer<typeof DraftLeadPackagedServiceSchema>;

// ==================
// Project Value Range Schema
// ==================

/** Budget range info in draft lead */
export const DraftLeadProjectValueRangeSchema = z.object({
    id: z.number().int(),
    label: z.string(),
});

export type DraftLeadProjectValueRange = z.infer<typeof DraftLeadProjectValueRangeSchema>;

// ==================
// Admin User Schema (for created_by_admin)
// ==================

/** Admin user info who created the draft */
export const DraftLeadAdminSchema = z.object({
    id: z.number().int(),
    name: z.string(),
});

export type DraftLeadAdmin = z.infer<typeof DraftLeadAdminSchema>;

// ==================
// Required fields for submission
// ==================

/** List of fields that can be missing from a draft */
export const DraftLeadMissingFieldsEnum = z.enum([
    "email",
    "first_name",
    "last_name",
    "project_title",
    "store_url",
    "urgency",
    "matching_strategy",
    "selected_expert_id",
]);

export type DraftLeadMissingField = z.infer<typeof DraftLeadMissingFieldsEnum>;
